import classnames from 'classnames';
import { Checkbox } from '@doda/io-react/common';
import React, { ComponentProps } from 'react';
import styles from './index.module.scss';

/**
 * CheckboxItemSのProps
 */
interface Props {
  /** チェックボックスのタイトル */
  title: string;
  /** チェックボックスの値 */
  value: ComponentProps<typeof Checkbox>['value'];
  /** 求人数（オプション） */
  numberOfJobs?: number;
  /** チェックボックスの変更イベントハンドラー */
  onChange: ComponentProps<typeof Checkbox>['onChange'];
  /** チェックボックスがチェックされているかどうか（オプション） */
  checked?: boolean;
}

export const CheckboxItemS: React.FC<Props> = ({
  title,
  value,
  numberOfJobs,
  onChange,
  checked,
}) => {
  return (
    <li className={styles.checkboxItemS}>
      <Checkbox
        onChange={onChange}
        value={value ?? title}
        checked={checked ?? false}
        label={
          <span
            className={classnames(styles.checkboxItemS__title, {
              [styles['checkboxItemS__title--checked']]: checked,
            })}
          >
            {title}
            {numberOfJobs !== undefined && (
              <span className={styles.checkboxItemS__numberOfJobs}>
                {`(${numberOfJobs.toLocaleString()})`}
              </span>
            )}
          </span>
        }
      />
    </li>
  );
};
